import React, { useEffect, useState } from "react";

import { KanbanCRM } from "./KanbanCRM";
import api from "../../../services/api";


export function CRM() {


  const [contatos, setContatos] = useState([]);

  const [loading, setLoading] = useState(true);



  async function carregarContatos(){


    try {


      const resposta = await api.get(
        "/auth/clientes.php"
      );


      setContatos(
        resposta.data
      );


    } catch(error){

      console.error(
        "Erro ao carregar contatos",
        error
      );

    } finally {

      setLoading(false);

    }


  }



  useEffect(()=>{

    carregarContatos();

  },[]);



  async function atualizarStatus(id, status){


    try {


      await api.put(
        "/auth/cliente-status.php",
        {
          id,
          status
        }
      );


      carregarContatos();


    } catch(error){

      console.error(
        "Erro ao atualizar status",
        error
      );

    }


  }




  if(loading){

    return (

      <div>
        Carregando CRM...
      </div>

    );

  }



  return (

    <div className="space-y-6">


      <div>


        <h1
          className="
          font-display
          text-h2
          font-bold
          text-text-primary
          "
        >
          CRM Comercial
        </h1>


        <p
          className="
          text-text-secondary
          "
        >
          Gerencie seus contatos pelo funil de vendas.
        </p>


      </div>



      <KanbanCRM

        contatos={contatos}

        onStatusChange={atualizarStatus}

      />


    </div>

  );

}